<script>
    import { uniqueId } from 'lodash';

    import Number from '../Number.svelte';
    import { bindClass } from 'src/utils/forms';

    export let state;
    export let fieldName;
    export let value;
    export let required = false;

    let componentId = uniqueId('landings-state-field-');
</script>

<div class="field" use:bindClass={{ state, name: fieldName }}>
    <label class="label" class:required for={componentId}>Landings</label>
    <Number
        id={componentId}
        min="0"
        bind:value
        {...$$restProps}
    />
</div>
